module.exports = __webpack_public_path__ + "media/assets/circleDrawing-b33f51b90b5d9f91e58ecfd5822c3f57.svg";